<template>
    <div>
        <div class="form">
            <div class="grid-x">
                <div class="cell small-1 medium-1 large-1 flexbox-center">
                    <icon class="small-svg fill-dark-gray" name="envelope" />
                </div>
                <div class="cell small-3 medium-3 large-3 border-bottom" :class="{'border-bottom-last': existingUser}">
                    <p class="custom-modal-text-alignment">E-mail</p>
                </div>
                <div class="cell auto border-bottom" :class="{'border-bottom-last': existingUser}">
                    <email-validation :newUser="newUser" :autofocus="true" v-model="user.email" @validateEmail="validEmailResult" />
                </div>
            </div>
        </div>
        <div class="relative">
            <div v-if="checkingUserFeedback" class="checking-user-existing-feedback">
                <div class="spinner-container spinner-container-modal">
                    <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
            <div class="form" style="margin-top: -10px;">
                <div class="grid-x">
                    <div class="cell small-1 medium-1 large-1 flexbox-center">
                        <icon class="small-svg fill-dark-gray" name="user" />
                    </div>
                    <div class="cell small-3 medium-3 large-3 border-bottom">
                        <p class="custom-modal-text-alignment">Navn</p>
                    </div>
                    <div class="cell auto border-bottom">
                        <input type="text" ref="username" @blur="$emit('validate')" v-model="user.name" :disabled="validateEmailField()">
                    </div>
                </div>
            </div>
            <div class="form" style="margin-top: -10px;">
                <div class="grid-x">
                    <div class="cell small-1 medium-1 large-1 flexbox-center">
                        <icon class="small-svg fill-dark-gray" name="phone" />
                    </div>
                    <div class="cell small-3 medium-3 large-3 border-bottom">
                        <p class="custom-modal-text-alignment">Telefon</p>
                    </div>
                    <div class="cell auto border-bottom">
                        <input type="text" v-model="user.phoneNumber" @blur="$emit('validate')" :disabled="validateEmailField()">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Switches from 'vue-switches'
import emailValidation from './../../shared/email/email-validation.vue'

export default {
    name: 'administration-modal-user-info',
    components: {
        Switches,
        'email-validation': emailValidation
    },
    data () {
        return {
            newUser: false,
            validEmail: true,
            checkingUserFeedback: false,
            // notifications
            enabledEnquiry: false,
            enabledTask: false,
            enabledRequisition: false
        }
    },
    computed: {
        ...mapGetters({
            selectedMultipleSupplyType: 'getSelectedMultipleSupplyType',
            selectedOrganization: 'getSelectedOrganization',
            applicationGroupList: 'getApplicationGroupList',
            application: 'getApplication',
            sysBusinessAreaTypeList: 'getSysBusinessAreaTypeList',
            existingUser: 'getUserExist',
            organizationEmployeeList: 'getOrganizationEmployeeList',
            selectedCompanies: 'getSelectedCompanies',
            user: 'getEmployee'
        })
    },
    methods: {
        ...mapActions({
            setCreateUser: 'setCreateUser',
            setUpdateUser: 'setUpdateUser',
            setActivateUser: 'setActivateUser',
            setDeactivateUser: 'setDeactivateUser',
            setNonSelectedMultipleSupplyType: 'setNonSelectedMultipleSupplyType',
            setUserExist: 'setUserExist',
            setApplicationGroupList: 'setApplicationGroupList'
        }),

        validateEmailField () {
            if (!this.user.email || (this.user.email && !this.validEmail)) {
                return true
            } else {
                return false
            }
        },
        validEmailResult (result) {
            let mailValid = false
            if (result && !this.existingUser) {
                mailValid = true
                this.$nextTick(() => this.$refs.username.focus())
            } else {
                mailValid = false
            }

            if (result && !this.user.userId && this.user.email) {
                this.checkingUserFeedback = true
                if (this.organizationEmployeeList.filter(employee => employee.email === this.user.email).length > 0) {
                    let context = this.selectedCompanies.length > 0 ? this.selectedCompanies[0].name : this.selectedOrganization.name
                    this.$notify({group: 'info', type: 'warn', title: '', text: 'En bruger med samme e-mail er allerede oprettet i ' + context + '. Brug en anden e-mail'})
                    this.checkingUserFeedback = false
                    mailValid = false
                } else {
                    new Promise((resolve, reject) => {
                        resolve(this.setUserExist(this.user.email))
                    }).then(() => {
                        this.checkingUserFeedback = false
                    })
                }
            }
            this.validEmail = mailValid
        }
    },
    mounted () {
        if (!this.user.userId) {
            this.validEmail = false
            this.newUser = true
        } else {
            this.$nextTick(() => this.$refs.username.focus())
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-modal-user-info.vue